/**
 * Menu - Adds states classes to burger menu
 *
 * TODO: toggle class using the input checkbox as a boolean argument (:checked)
 */
function $menuify (attrString, callback) {
    attrString = attrString || 'js-menu-burger';
    var $menu = $(`[${attrString}]`);

    /** Setup each menu, in case we have multiple instances */
    $menu.each (function () {
        var $this = $(this),
            attr = $(this).attr(attrString),
            $burger = $(attr) || false;

        if (!$burger.length) $burger = $this;

        $this.bind('click.menu-burger keydown.menu-burger', function (event) {
            $burger.toggleClass('is-active');
            if (typeof callback === 'function') callback.call(this, event);
        });
    });

}

export default $menuify;



// WEBPACK FOOTER //
// ./src/js/app/components/menu.js